function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import useData from "./data";
import { isAdani } from "../../../../utils/isClient";
import DealsLayout from "../DealsLayout/newIndex";
import CustomSelect from "../../../Common/CustomSelect";
import SearchBar from "../../../Common/SearchBar";
import { filterSvg, loadMoreSvg, noDealsvg } from "./svg";
import SideModal from "../../../Common/SideModal";
import GrClose from "@meronex/icons/gr/GrClose";
import SkeletonGeneralOffer from "../../../Common/Skeleton/SkeletonCategoryBar/SkeletonGeneralOffer";
import DealSection from "../DealSection";
import ZeroState from "../../../Common/ZeroState";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/styles.css";

// Create AutoplaySlider component
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AutoplaySlider = withAutoplay(AwesomeSlider);

// Banner images array
var banners = ["https://cdn.loyalie.in/1742833676370_deal-1", "https://cdn.loyalie.in/1742833769545_deal-3"];
var filterOptions = ["Categories", "Tags", "Brands"];
function ProductListing(_ref) {
  var _redux$webView, _config$sectionBackgr, _config$sectionBackgr2, _config$sectionBackgr3, _config$sectionBackgr4, _config$sectionBackgr5, _config$sectionBackgr6, _config$sectionBackgr7, _config$sectionBackgr8, _config$blogs, _config$blogs2, _config$blogs3, _config$blogs4;
  var isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    isCustom = _ref.isCustom,
    config = _ref.config,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMobileFilter = _useState2[0],
    setOpenMobileFilter = _useState2[1];
  var _useState3 = useState("Categories"),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedMobileFilter = _useState4[0],
    setSelectedMobileFilter = _useState4[1];
  var isAdaniClient = isAdani(config);
  var titleFont = isAdaniClient && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontTitle) || '' : '';
  var bodyFont = isAdaniClient && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || '' : '';
  var _ref2 = router || {},
    location = _ref2.location;
  var internalWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview;
  var _useData = useData(isRewards, isCustom, {
      redux: redux,
      router: router,
      config: config,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }, isPoints),
    offers = _useData.offers,
    type = _useData.type,
    categories = _useData.categories,
    brands = _useData.brands,
    handleChange = _useData.handleChange,
    searchInput = _useData.searchInput,
    selectedTags = _useData.selectedTags,
    selectedBrands = _useData.selectedBrands,
    selectedCategories = _useData.selectedCategories,
    setSelectedTags = _useData.setSelectedTags,
    setSelectedBrands = _useData.setSelectedBrands,
    setSelectedCategories = _useData.setSelectedCategories,
    totalPages = _useData.totalPages,
    clearFilters = _useData.clearFilters,
    setLoadMoreOffers = _useData.setLoadMoreOffers,
    loadMoreOffers = _useData.loadMoreOffers,
    tags = _useData.tags,
    loadingOffers = _useData.loadingOffers,
    topOffers = _useData.topOffers;
  var formattedTags = tags === null || tags === void 0 ? void 0 : tags.map(function (tag) {
    return {
      value: tag.id,
      label: tag.name
    };
  });
  var formattedCategories = categories === null || categories === void 0 ? void 0 : categories.filter(function (category) {
    return category.id !== 4 && category.id !== 6 && category.id !== 7;
  }).map(function (category) {
    return {
      value: category.id,
      label: category.name
    };
  });
  var formattedBrands = brands === null || brands === void 0 ? void 0 : brands.map(function (brand) {
    return {
      value: brand.id,
      label: brand.name
    };
  });
  // console.log('top Offers', topOffers);
  // console.log('selected categories', selectedCategories);
  // console.log('selectedTags', selectedTags);

  var applyFilter = function applyFilter(filterState, setFun, option) {
    // console.log('apply', option);
    if (!!filterState.find(function (element) {
      return element.value == option.value;
    })) {
      setFun(function (prev) {
        return _toConsumableArray(prev.filter(function (e) {
          return e.value != option.value;
        }));
      });
    } else {
      setFun(function (prev) {
        return [].concat(_toConsumableArray(prev), [option]);
      });
    }
  };
  // console.log('look', formattedCategories, selectedCategories);
  console.log("selectedCategories", selectedCategories);
  var renderFilterOptions = function renderFilterOptions() {
    switch (selectedMobileFilter) {
      case "Categories":
        return formattedCategories === null || formattedCategories === void 0 ? void 0 : formattedCategories.map(function (category) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex items-start gap-x-3 py-2",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              value: category.value,
              checked: !!selectedCategories.find(function (option) {
                return option.value == category.value;
              }),
              onClick: function onClick() {
                applyFilter(selectedCategories, setSelectedCategories, category);
              },
              className: "checkbox-md bg-white rounded-md border-2 checked:bg-primary mt-1 flex-shrink-0",
              autoComplete: "off"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm leading-5 break-words",
              children: category.label
            })]
          }, category.value);
        });
      case "Tags":
        return formattedTags === null || formattedTags === void 0 ? void 0 : formattedTags.map(function (tag) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex items-start gap-x-3 py-2",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              value: tag.value,
              checked: !!selectedTags.find(function (option) {
                return option.value == tag.value;
              }),
              onClick: function onClick() {
                return applyFilter(selectedTags, setSelectedTags, tag);
              },
              className: "checkbox-md bg-white rounded-md border-2 checked:bg-primary mt-1 flex-shrink-0",
              autoComplete: "off"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm leading-5 break-words",
              children: tag.label
            })]
          }, tag.value);
        });
      case "Brands":
        return formattedBrands === null || formattedBrands === void 0 ? void 0 : formattedBrands.map(function (brand) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex items-start gap-x-3 py-2",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              value: brand.value,
              checked: !!selectedBrands.find(function (option) {
                return option.value == brand.value;
              }),
              onClick: function onClick() {
                return applyFilter(selectedBrands, setSelectedBrands, brand);
              },
              className: "checkbox-md bg-white rounded-md border-2 checked:bg-primary mt-1 flex-shrink-0",
              autoComplete: "off"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm leading-5 break-words",
              children: brand.label
            })]
          }, brand.value);
        });
      default:
        return null;
    }
  };
  var handleTagsChange = function handleTagsChange(selected) {
    console.log("option clicked", selected);
    setSelectedTags(function () {
      return [].concat(_toConsumableArray(selectedTags), _toConsumableArray(selected));
    });
  };
  var allFiltersApplied = [].concat(_toConsumableArray(selectedCategories.map(function (c) {
    return _objectSpread(_objectSpread({}, c), {}, {
      type: "Category"
    });
  })), _toConsumableArray(selectedTags.map(function (t) {
    return _objectSpread(_objectSpread({}, t), {}, {
      type: "Tag"
    });
  })), _toConsumableArray(selectedBrands.map(function (b) {
    return _objectSpread(_objectSpread({}, b), {}, {
      type: "Brand"
    });
  })));
  var removeAppliedFilter = function removeAppliedFilter(type, value) {
    switch (type) {
      case "Category":
        setSelectedCategories(selectedCategories.filter(function (tag) {
          return tag.value != value;
        }));
        break;
      case "Tag":
        setSelectedTags(selectedTags.filter(function (tag) {
          return tag.value != value;
        }));
        break;
      case "Brand":
        setSelectedBrands(selectedBrands.filter(function (tag) {
          return tag.value != value;
        }));
        break;
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(internalWebview ? "mb-16" : "", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), " ").concat(bodyFont),
    style: {
      backgroundImage: "linear-gradient(90deg, rgba(".concat(config === null || config === void 0 || (_config$sectionBackgr = config.sectionBackground) === null || _config$sectionBackgr === void 0 ? void 0 : _config$sectionBackgr.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr2 = config.sectionBackground) === null || _config$sectionBackgr2 === void 0 ? void 0 : _config$sectionBackgr2.opacity, "), rgba(").concat(config === null || config === void 0 || (_config$sectionBackgr3 = config.sectionBackground) === null || _config$sectionBackgr3 === void 0 ? void 0 : _config$sectionBackgr3.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr4 = config.sectionBackground) === null || _config$sectionBackgr4 === void 0 ? void 0 : _config$sectionBackgr4.opacity, ")), url('").concat(config !== null && config !== void 0 && (_config$sectionBackgr5 = config.sectionBackground) !== null && _config$sectionBackgr5 !== void 0 && _config$sectionBackgr5.image ? config === null || config === void 0 || (_config$sectionBackgr6 = config.sectionBackground) === null || _config$sectionBackgr6 === void 0 ? void 0 : _config$sectionBackgr6.image : "", "')"),
      backgroundSize: "".concat(config !== null && config !== void 0 && (_config$sectionBackgr7 = config.sectionBackground) !== null && _config$sectionBackgr7 !== void 0 && _config$sectionBackgr7.size ? config === null || config === void 0 || (_config$sectionBackgr8 = config.sectionBackground) === null || _config$sectionBackgr8 === void 0 ? void 0 : _config$sectionBackgr8.size : "30% auto")
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto  "),
      children: (config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
        className: config === null || config === void 0 ? void 0 : config.header.headerClass
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: " ".concat(isCustom ? "w-full mx-auto" : "w-full lg:w-[90%] mx-auto lg:pt-10"),
      children: [isCustom &&
      /*#__PURE__*/
      // <AutoplaySlider
      //     bullets={false}
      //     play={true}
      //     cancelOnInteraction={false}
      //     interval={3000}
      //     organicArrows={false}
      //     className=" w-full h-[400px] mx-auto rounded-lg"
      //     style={{
      //         backgroundColor: 'transparent',
      //         borderRadius: '12px',
      //         overflow: 'hidden'
      //     }}
      // >
      // {banners.map((banner, index) => (
      // <div
      //     // key={index}
      //     className="w-full h-full flex justify-center items-center"
      // >
      //     <img
      //         src={
      //             'https://cdn.loyalie.in/1744803101455_HOUSE OF EMBASSY'
      //         }
      //         className="w-full h-full object-contain rounded-xl"
      //         // alt={`banner-${index}`}
      //     />
      // </div>
      _jsx("div", {
        style: {
          width: "100%",
          paddingBottom: "34.82%",
          position: "relative"
        },
        children: /*#__PURE__*/_jsx("picture", {
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "https://cdn.loyalie.in/1751287621136_EMBASSY%20ONLY",
            alt: "Banner",
            style: {
              width: "100%",
              height: "100%",
              objectFit: "cover"
            },
            className: ""
          })
        })
      })
      // ))}
      // </AutoplaySlider>
      , !isCustom && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "border-b-2 py-4 px-4 lg:px-0 ".concat(internalWebview ? "sticky top-0 z-10 bg-white" : ""),
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex gap-x-2 ",
            children: [/*#__PURE__*/_jsx(SearchBar, {
              width: "w-full lg:w-[40%]",
              searchValue: searchInput,
              onSearchChange: handleChange,
              config: config,
              redux: redux,
              router: router
            }), /*#__PURE__*/_jsxs("div", {
              className: "hidden w-full lg:flex gap-x-2",
              children: [/*#__PURE__*/_jsx(CustomSelect, {
                onChangeCallback: function onChangeCallback(categories) {
                  // console.log(categories)
                  setSelectedCategories(categories);
                },
                placeholder: "Select Categories",
                className: "w-full",
                options: formattedCategories,
                selectedValues: selectedCategories,
                config: config
              }), /*#__PURE__*/_jsx(CustomSelect, {
                onChangeCallback: function onChangeCallback(tags) {
                  // console.log('from select', tags)
                  setSelectedTags(tags);
                },
                placeholder: "Tags",
                className: "w-full",
                options: formattedTags,
                selectedValues: selectedTags,
                config: config
              }), /*#__PURE__*/_jsx(CustomSelect, {
                onChangeCallback: function onChangeCallback(brands) {
                  // console.log(" From Brands" ,brands)
                  setSelectedBrands(brands);
                },
                placeholder: "Brands",
                className: "w-full",
                options: formattedBrands,
                selectedValues: selectedBrands,
                config: config
              })]
            }), /*#__PURE__*/_jsx("div", {
              onClick: function onClick() {
                return setOpenMobileFilter(true);
              },
              className: "flex items-center justify-center py-2 px-4 lg:hidden rounded-lg border border-[#DDDDDD]",
              children: filterSvg(config === null || config === void 0 ? void 0 : config.darkMode)
            })]
          })
        }), allFiltersApplied.length > 0 && /*#__PURE__*/_jsx("div", {
          className: "py-2 lg:py-4 px-4 lg:px-0",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between mt-2",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-full md:w-[75%] flex flex-wrap gap-x-2 gap-y-2",
              children: allFiltersApplied.map(function (filter) {
                return /*#__PURE__*/_jsxs("button", {
                  className: "text-sm md:text-base lg:text-sm xl:text-base bg-[#f0f0f0] text-[#333c4d] font-medium rounded-2xl py-1 px-3 ",
                  children: [filter.label, /*#__PURE__*/_jsx("span", {
                    className: "ml-2 cursor-pointer",
                    children: /*#__PURE__*/_jsx(GrClose, {
                      onClick: function onClick() {
                        return removeAppliedFilter(filter.type, filter.value);
                      },
                      className: "inline h-3 w-3 "
                    })
                  })]
                });
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[25%] hidden lg:flex justify-end self-start",
              children: /*#__PURE__*/_jsx("button", {
                onClick: clearFilters,
                className: " text-sm text-[#16519E] underline font-medium",
                children: "Clear all"
              })
            })]
          })
        })]
      }), isCustom && /*#__PURE__*/_jsxs("div", {
        className: "w-full lg:w-[90%]  text-center mx-auto",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-[22px] md:text-[24px] lg:text-[25px] xl:text-[31px] tracking-wider leading-7 mt-14 ".concat(config === null || config === void 0 || (_config$blogs = config.blogs) === null || _config$blogs === void 0 ? void 0 : _config$blogs.fontHeading, " tracking-widest text-primary"),
          children: "WELCOME TO EMBASSY ONLY!"
        }), /*#__PURE__*/_jsx("p", {
          className: "mt-12 text-[18px] xl:text-[22px] leading-6 xl:leading-[27px] ".concat(config === null || config === void 0 || (_config$blogs2 = config.blogs) === null || _config$blogs2 === void 0 ? void 0 : _config$blogs2.fontBody),
          children: "Embassy only is your gateway to curated offers, premium services and exclusive perks from across the Embassy universe. From hospitality to wellness, dining to retail, enjoy a lifestyle designed for ease and indulgence."
        }), /*#__PURE__*/_jsx("p", {
          className: "mt-7 text-[18px] xl:text-[22px] leading-6 xl:leading-[27px] ".concat(config === null || config === void 0 || (_config$blogs3 = config.blogs) === null || _config$blogs3 === void 0 ? void 0 : _config$blogs3.fontBody),
          children: "Because when you\u2019re part of Embassy, you don\u2019t just get a home. You get the lifestyle that comes with it."
        }), /*#__PURE__*/_jsx("h3", {
          className: "text-primary text-[21px] lg:text-[24px] xl:text-3xl leading-7 xl:leading-9 mt-10 mb-10 ".concat(config === null || config === void 0 || (_config$blogs4 = config.blogs) === null || _config$blogs4 === void 0 ? void 0 : _config$blogs4.fontHeading),
          children: "Our Finest, Curated for You."
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "pb-6",
        children: [offers.length > 0 && !isCustom && /*#__PURE__*/_jsx("h1", {
          className: "mt-2 lg:mt-7 font-bold text-center lg:text-left ".concat(titleFont),
          children: searchInput.length > 0 ? "Search Results" : "Product List"
        }), loadingOffers && loadMoreOffers <= 8 && /*#__PURE__*/_jsx("div", {
          className: "flex flex-wrap justify-center  ".concat(isCustom ? "lg:justify-center" : "lg:justify-start", " gap-2 xl:gap-4 mt-4"),
          children: _toConsumableArray(Array(8).keys()).map(function (n) {
            return /*#__PURE__*/_jsx(SkeletonGeneralOffer, {}, n);
          })
        }), offers.length == 0 && (!loadingOffers || loadMoreOffers > 8) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "".concat(isCustom ? "w-full lg:w-[90%] mx-auto" : ""),
            children: /*#__PURE__*/_jsx(ZeroState, {
              type: "deals"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "w-[93%] ".concat(isCustom ? "lg:w-[90%]" : "lg:w-full", " mx-auto pt-2 pb-5"),
            children: topOffers.length > 0 && /*#__PURE__*/_jsx(DealSection, {
              type: "OFFERS OF THE MONTH",
              offers: topOffers.slice(0, 5),
              className: "mt-7",
              hide: true,
              isRewards: isRewards,
              isPoints: isPoints
            })
          })]
        }), selectedCategories.some(function (category) {
          return category.value === 9;
        }) && /*#__PURE__*/_jsx("div", {
          className: "flex flex-wrap justify-center gap-y-5 gap-x-3 xl:gap-4 pt-4 pb-10 ".concat(isCustom ? "lg:justify-center lg:w-[90%]" : "lg:justify-start", " ").concat(selectedCategories.length > 1 && "border-b border-b-[#DDDDDD]"),
          children: (!loadingOffers || loadMoreOffers > 8) && (offers === null || offers === void 0 ? void 0 : offers.filter(function (offer) {
            return offer.categoryName === "External";
          }).map(function (offer) {
            var modifiedOffer = _objectSpread(_objectSpread({}, offer), {}, {
              isRewards: isRewards,
              isPoints: isPoints,
              config: config,
              redux: redux,
              router: router,
              winnreAuth: winnreAuth,
              winnreNoAuth: winnreNoAuth,
              cmsClient: cmsClient
            }); // Pass required props through to DealsLayout
            return /*#__PURE__*/_jsx(DealsLayout, _objectSpread(_objectSpread({}, modifiedOffer), {}, {
              fromProductPage: true,
              className: "w-[45%] md:w-[40%] lg:w-[32%] "
            }));
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: "flex flex-wrap justify-center ".concat(isCustom ? "lg:justify-center lg:w-[90%]" : "lg:justify-start", "  gap-y-5 gap-x-4 xl:gap-4 pb-10 ").concat(selectedCategories.length > 0 ? "pt-10" : "pt-4"),
          children: (!loadingOffers || loadMoreOffers > 8) && (offers === null || offers === void 0 ? void 0 : offers.filter(function (offer) {
            return offer.categoryName !== "External";
          }).map(function (offer) {
            var modifiedOffer = _objectSpread(_objectSpread({}, offer), {}, {
              isRewards: isRewards,
              isPoints: isPoints,
              config: config,
              redux: redux,
              router: router,
              winnreAuth: winnreAuth,
              winnreNoAuth: winnreNoAuth,
              cmsClient: cmsClient
            }); // Pass required props through to DealsLayout
            return /*#__PURE__*/_jsx(DealsLayout, _objectSpread(_objectSpread({}, modifiedOffer), {}, {
              fromProductPage: true,
              isCustom: isCustom
            }));
          }))
        }), totalPages > 1 && /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return setLoadMoreOffers(function (prev) {
              return prev + 8;
            });
          },
          className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-20",
          children: loadingOffers ? "Loading..." : /*#__PURE__*/_jsxs(_Fragment, {
            children: ["Load More", loadMoreSvg]
          })
        })]
      }), /*#__PURE__*/_jsx(SideModal, {
        visible: openMobileFilter,
        onClick: function onClick() {
          return setOpenMobileFilter(false);
        },
        onlyMobile: true,
        className: "w-full !w-full max-w-full left-0 right-0 ml-0",
        config: config,
        children: /*#__PURE__*/_jsxs("div", {
          className: "h-screen flex flex-col",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex justify-between items-start p-4 flex-shrink-0 border-b border-gray-200",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "font-bold text-lg",
              children: "Filters"
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-x-3",
              children: [/*#__PURE__*/_jsx("h1", {
                onClick: function onClick() {
                  return clearFilters();
                },
                className: "text-sm text-[#16519E] underline font-medium whitespace-nowrap cursor-pointer",
                children: "Clear all filters"
              }), /*#__PURE__*/_jsx(GrClose, {
                onClick: function onClick() {
                  return setOpenMobileFilter(false);
                },
                className: "h-3 w-3 cursor-pointer text-gray-700"
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-1 overflow-hidden",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-[35%] border-r border-gray-200 flex-shrink-0",
              children: filterOptions.map(function (option) {
                return /*#__PURE__*/_jsx("p", {
                  onClick: function onClick() {
                    return setSelectedMobileFilter(option);
                  },
                  className: "".concat(selectedMobileFilter == option ? "bg-primary text-white" : "bg-gray-50 ".concat(config !== null && config !== void 0 && config.darkMode ? 'text-gray-700' : ''), " border-b border-gray-100 p-3 cursor-pointer text-sm font-medium"),
                  children: option
                }, option);
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "w-[65%] flex flex-col overflow-hidden",
              children: [/*#__PURE__*/_jsx("div", {
                className: "px-4 py-3 flex-shrink-0 border-b border-gray-100",
                children: /*#__PURE__*/_jsx("h1", {
                  className: "font-semibold text-base",
                  children: selectedMobileFilter
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "px-4 py-2 overflow-y-auto flex-1",
                children: renderFilterOptions()
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "p-4 pb-6 flex-shrink-0 border-t border-gray-200",
            children: [/*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                return setOpenMobileFilter(false);
              },
              className: "bg-primary text-white w-full rounded-lg py-3 font-bold text-base mb-3",
              children: "Apply Filter"
            }), /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                return setOpenMobileFilter(false);
              },
              className: "bg-gray-100 text-gray-700 w-full rounded-lg py-3 font-medium text-base border border-gray-300",
              children: "Cancel"
            })]
          })]
        })
      })]
    })]
  });
}
export default ProductListing;